import React, { createElement, useState } from 'react'

import { Link } from 'react-router-dom'

import appConfig from '@src/appConfig.json'

import useDocumentTitle from '@hooks/useDocumentTitle'
import { useLoader } from '@hooks/useLoader'

import { loadTemplate } from '@helpers/loadTemplate'

function Pp() {
  useDocumentTitle(appConfig.pageTitle.pp)

  const [text, setText] = useState(null)

  const rules = [
    {
      name: 'static-links',
      match: ({ type, attributes }) => {
        return type === 'a' && attributes['data-link'] && attributes['data-link'] === 'static'
          ? true
          : false
      },
      cb: ({ attributes, children }) => {
        return createElement(
          Link,
          {
            ...attributes,
            to: `/`,
          },
          children,
        )
      },
    },
  ]

  const isLoading = useLoader(async () => {
    const data = await loadTemplate('pp')
    if (data) {
      setText(data)
    }
  })

  return (
    !isLoading &&
    text.map((x) =>
      window.ziphyTosRenderJSON({
        json: x,
        rules,
        createElement: React.createElement,
        disabledRules: ['hidden'],
      }),
    )
  )
}

export default Pp
